export const ItemTypes = {
  UNARRANGED_APP_ELEMENT: 'unarranged_app_element',
};
